import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const malad: AreaConfig = {
  name: 'Malad',
  slug: 'malad',
  tagline: 'Doorstep Mobile Repair in Malad, Mumbai',
  description:
    'Minto brings certified mobile repair to your doorstep in Malad East and West. From Inorbit Mall area to Malwani and Marve — screen replacement, battery repair, and more done in under an hour at your location.',
  localities: [
    'Malad West', 'Malad East', 'Inorbit Mall Area', 'Mindspace', 'Marve',
    'Malwani', 'Orlem', 'Kurar Village', 'Dindoshi', 'Raheja Township',
    'Evershine Nagar', 'Chincholi Bunder', 'S.V. Road', 'Link Road',
  ],
  zones: [
    {
      name: 'Malad West — Inorbit & Mindspace',
      line: 'Western Line',
      station: 'Malad West Station',
      localities: ['Inorbit Mall', 'Mindspace', 'Malad West', 'Marve Road', 'Evershine Nagar', 'Raheja Township', 'Orlem', 'IC Nagar'],
      desc: 'Malad West is a premium residential and commercial zone. Our technicians cover Mindspace IT park offices and residential towers near Inorbit Mall.',
    },
    {
      name: 'Malwani & Marve',
      line: 'Western Line',
      station: 'Malad West Station',
      localities: ['Malwani', 'Marve', 'Chincholi Bunder', 'Jankalyan Nagar', 'Poisar adjacent'],
      desc: 'Covering the coastal western localities of Malad including Malwani and Marve beach road.',
    },
    {
      name: 'Malad East — Kurar & Dindoshi',
      line: 'Western Line',
      station: 'Malad East Station',
      localities: ['Malad East', 'Kurar Village', 'Dindoshi', 'Pathan Wadi', 'Link Road East', 'Oberoi Complex'],
      desc: 'Malad East residents can book doorstep repair with ease. Kurar Village, Dindoshi, and the Oberoi area are all fully covered.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Malad | Doorstep Phone Repair | Minto',
    description:
      'Doorstep mobile repair in Malad East & West, Inorbit, Mindspace, Malwani & Marve, Mumbai. Screen replacement, battery repair. 90-day warranty. Book now!',
    keywords:
      'mobile repair Malad, phone repair Malad, screen repair Malad, battery replacement Malad, iPhone repair Malad, Samsung repair Malad, Mindspace phone repair, Inorbit mobile repair, Malwani phone repair, Marve mobile repair, doorstep repair Malad',
  },
  faqs: [
    {
      q: 'Do you offer mobile repair near Inorbit Mall in Malad?',
      a: 'Yes, we cover the entire Inorbit and Mindspace zone in Malad West, including nearby residential buildings.',
    },
    {
      q: 'Can you repair phones in Malwani and Marve?',
      a: 'Yes, Malwani and Marve are within our Malad service zone with same-day availability.',
    },
    {
      q: 'Do you also cover Malad East?',
      a: 'Yes, Malad East including Kurar Village, Dindoshi, and the Oberoi area are fully covered.',
    },
    {
      q: 'How much does battery replacement cost in Malad?',
      a: 'Battery replacement starts from ₹699 depending on your phone model. Check the exact price on our booking page.',
    },
    {
      q: 'Is there a warranty on repairs in Malad?',
      a: 'Yes, all repairs carry a 90-day warranty with free re-repair if the same issue recurs.',
    },
  ],
};

const MaladPage: React.FC = () => <AreaLandingPage area={malad} />;
export default MaladPage;
